import { auth } from './auth'
import { api } from './api'
import { clearLocalPush } from './notification-lifecycle'
export async function signOutSafely() {
  const subscription = 'serviceWorker' in navigator
    ? await (await navigator.serviceWorker.getRegistration('/'))?.pushManager?.getSubscription()
    : null
  if (subscription) {
    // Either revocation is sufficient to prevent further delivery. Try both while authenticated.
    const results = await Promise.allSettled([api.pushUnsubscribe(subscription.endpoint), clearLocalPush()])
    if (results.every(result => result.status === 'rejected')) throw Error('Não foi possível desativar os avisos deste dispositivo. Verifique a conexão e tente sair novamente.')
  } else await clearLocalPush()
  await auth.signOut()
  window.dispatchEvent(new Event('celeiro:unauthorized'))
}
